import { useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import type { ErpModule } from '@/api/platform.api';
import { getModuleEntryByErpModule } from '@/config/moduleEntries';
import { resolveModuleFromAdminPath } from '@/config/moduleDefaults';
import { resolveWorkspaceModule } from '@/config/moduleWorkspace';
import { useAppSelector } from '@/hooks/useAppSelector';

export function useWorkspaceModule(): {
  module: ErpModule | null;
  moduleLabel: string;
  ready: boolean;
} {
  const entryModule = useAppSelector((s) => s.auth.entryModule);
  const [params] = useSearchParams();
  const moduleParam = params.get('module');
  const { pathname } = useLocation();

  return useMemo(() => {
    const fromPath = resolveModuleFromAdminPath(pathname);
    const module = fromPath ?? resolveWorkspaceModule(moduleParam, entryModule);
    const moduleLabel = module ? (getModuleEntryByErpModule(module)?.label ?? module) : 'Module';
    return { module, moduleLabel, ready: module != null };
  }, [moduleParam, entryModule, pathname]);
}
